import { render, staticRenderFns } from "./QuestionReadingBoolean.vue?vue&type=template&id=06a2faf7"
import script from "./QuestionReadingBoolean.vue?vue&type=script&lang=js"
export * from "./QuestionReadingBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports